import { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';
import { resolveForbiddenFallbackPath } from '@/lib/forbidden-fallback';

const REDIRECT_SECONDS = 3;

export function ForbiddenPage() {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const fallbackPath = useMemo(() => resolveForbiddenFallbackPath(hasPermission), [hasPermission]);
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (secondsLeft <= 0) {
      navigate(fallbackPath, { replace: true });
      return;
    }

    const timerId = window.setTimeout(() => {
      setSecondsLeft((current) => current - 1);
    }, 1000);

    return () => window.clearTimeout(timerId);
  }, [secondsLeft, navigate, fallbackPath]);

  return (
    <div className="lms-forbidden font-sans">
      <div className="lms-forbidden__panel">
        <p className="lms-forbidden__code" aria-hidden="true">
          403
        </p>
        <h1 className="lms-forbidden__title">No autorizado</h1>
        <p className="lms-forbidden__message">No tienes permiso para acceder a este recurso.</p>
        <p className="lms-forbidden__timer" role="status" aria-live="polite">
          Serás redirigido en {secondsLeft} {secondsLeft === 1 ? 'segundo' : 'segundos'}…
        </p>
        <div className="lms-forbidden__actions">
          <Link to={fallbackPath} className="lms-forbidden__button">
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
